/* URS2GO homepage product rotator.
   The server renders the WHOLE pool (e.g. 80 cards); this only swaps which
   window of `per-page` is visible, so nothing reloads and the page keeps its
   scroll position. It advances on the SAME clock as the top bar countdown:
   the countdown element dispatches `urs2go:rotation` each time it wraps, and
   we listen for that. If no countdown exists on the page, we fall back to our
   own interval so rotation still happens. */
if (!customElements.get('urs2go-feed-rotator')) {
  customElements.define('urs2go-feed-rotator', class extends HTMLElement {
    connectedCallback() {
      this.init();
      if (!this._clockBound) {
        // 优先跟随顶部倒计时那条 clock line（每绕一圈 dispatches urs2go:rotation）
        document.addEventListener('urs2go:rotation', () => this.next());
        this._clockBound = true;
      }
      // 兜底：页面上没有倒计时（无 topbar）时用自己的定时器，别让轮换停摆
      if (!this._timerBound) {
        this._timerBound = true;
        const intervalMs = Math.max(2000, parseInt(this.dataset.interval || '100000', 10));
        let id = null;
        const hasClock = () => !!document.querySelector('urs2go-topbar[data-interval]');
        const start = () => { if (id === null && !hasClock()) id = setInterval(() => this.next(), intervalMs); };
        const stop = () => { if (id !== null) { clearInterval(id); id = null; } };
        document.addEventListener('visibilitychange', () => { if (document.hidden) { stop(); } else { start(); } });
        start();
      }
    }

    /* 2026-10-04：拆出 init() 供 refresh() 复用 —— 数据文件加载后会重建整列卡片，
       届时调用 rotator.refresh() 重新数卡片、重算池并重绘。 */
    init() {
      const cards = Array.from(this.querySelectorAll('.urs2go-feed__card[data-rot-idx]'));
      const per = Math.max(1, parseInt(this.dataset.perPage || '16', 10));
      // 2026-10-04 修（用户报「轮一圈后留空白」）：服务端渲染数可能小于设定池
      // （Shopify Liquid 的 collection 循环上限 50）⇒ 取「渲染数」与「设定池」的较小值，
      // 并向下取整到完整屏，保证每一屏都是满的、且到池尾能干净回绕。
      const settingPool = Math.max(per, parseInt(this.dataset.pool || String(cards.length), 10));
      let pool = Math.min(settingPool, cards.length);
      pool -= pool % per;
      this._cards = cards;
      this._per = per;
      this._offset = 0;
      // 2026-11-01（用户令「首页第一个产品固定显示 free gift，其余照常轮换」）：
      // 卡 0 = Free Gift 固定头牌（loader 在 items[0].fixed 时置 data-fixed-first），
      // 每屏第 1 格恒为卡 0；轮换池从卡 1 起。fixedFirst 未置位时行为与旧版完全一致。
      this._fixedFirst = this.dataset.fixedFirst === '1' && cards.length > per;
      if (this._fixedFirst) {
        if (pool <= per) { this._pool = 0; this._paintPinnedAll(); return; }
        this._pool = pool - 1;          // 轮换池 = 除头牌外的卡片数
        this.paint();
        return;
      }
      if (pool <= per) { this._pool = 0; this._paintAll(); return; }   // 不足两屏 ⇒ 不轮换（全部显示）
      this._pool = pool;
      this.paint();
    }

    refresh() { this.init(); }

    _paintAll() {
      this._cards.forEach((c) => {
        c.classList.remove('is-rot-hidden');
        c.classList.remove('urs2go-feed__card--reverse');
      });
    }

    _paintPinnedAll() {
      // 固定位模式但池不足两屏：全部显示，卡 0 依旧在最前（DOM 顺序天然如此）
      this._paintAll();
    }

    paint() {
      const cards = this._cards, per = this._per, pool = this._pool, offset = this._offset;
      if (!pool) return;
      for (let k = 0; k < cards.length; k++) cards[k].classList.add('is-rot-hidden');
      if (this._fixedFirst) {
        // 每屏第 1 格恒为卡 0（Free Gift），其余 per-1 格从卡 1..N-1 的窗口轮换
        if (cards[0]) {
          cards[0].classList.remove('is-rot-hidden');
          cards[0].classList.remove('urs2go-feed__card--reverse');
        }
        let shown = 1;
        for (let k = 0; k < per - 1; k++) {
          const idx = 1 + ((offset + k) % pool);
          const el = cards[idx];
          if (!el) continue;
          el.classList.remove('is-rot-hidden');
          el.classList.toggle('urs2go-feed__card--reverse', shown % 2 === 1);
          shown++;
        }
        return;
      }
      let shown = 0;
      for (let k = 0; k < per; k++) {
        const idx = (offset + k) % pool;
        const el = cards[idx];
        if (!el) continue;
        el.classList.remove('is-rot-hidden');
        el.classList.toggle('urs2go-feed__card--reverse', shown % 2 === 1);
        shown++;
      }
    }

    next() {
      if (!this._pool) return;
      this._offset = (this._offset + this._per) % this._pool;
      this.paint();
    }
  });
}
